// extracted by mini-css-extract-plugin
export default {"componentPadding":"Invalid_componentPadding__WvqLy","fullPageContainer":"Invalid_fullPageContainer__93BUV","relative":"Invalid_relative__86K09"};